module.exports = __webpack_public_path__ + "img/icon-arrow-back-floorplan.c1f5f61c.svg";